import { __assign } from "tslib";
export function createStylesParams(styles) {
    return Object.keys(styles).reduce(function (acc, key) {
        acc[key] = __assign(__assign({}, styles[key]), { key: styles[key].key || key });
        return acc;
    }, {});
}
export var createStylesParam = function (key, param) { return (__assign({ key: key }, param)); };
//# sourceMappingURL=createStylesParams.js.map